export var RateResult;
(function (RateResult) {
    RateResult["ALLOWED"] = "ALLOWED";
    RateResult["FORWARD_SEEKING_NOT_ALLOWED"] = "FORWARD_SEEKING_NOT_ALLOWED";
})(RateResult || (RateResult = {}));
